<template>
  <div class="fits-for">
    <div v-for="category of fitsFor" :key="category.id" class="fits-for-category">
      <h3 class="fits-for-category__headline">
        {{ category.name }}
      </h3>

      <div class="fits-for-category__container">
        <div v-for="brand of category.brands" :key="brand.id" class="fits-for-category__brand-container">
          <h4 class="fits-for-category__brand-headline">
            {{ brand.name }}
          </h4>

          <div class="grid grid--five grid--no-gap">
            <div v-for="chunk of chunkedData(brand.models)" :key="chunk.id">
              <template>
                <a
                  v-for="model of chunk"
                  :key="model.id"
                  :href="model.url"
                  class="fits-for-category__models-link">{{ model.name }}</a>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    fitsFor: {
      type: Array,
      required: true
    }
  },
  data: () => ({
    chunkSplit: 5
  }),
  methods: {
    chunkedData(data) {
      return this.createChunks(data)
    },
    createChunks(data) {
      const chunkSizes = { 'to-small': 2, 'to-medium': 3, 'to-large': 4, 'large': 5 }
      const matchingChunk = _.chain(_.keys(chunkSizes)).map(key => ({ value: this.breakpoints[key], key })).find(item => item.value).value()

      return matchingChunk ? _.chunk(data, Math.ceil(data.length / chunkSizes[matchingChunk.key])) : [data]
    }
  }
}
</script>

<style lang="scss">
.fits-for-category:not(:last-child) {
  margin-bottom: measure(half);
  padding-bottom: measure(half);
}

.fits-for-category__headline {
  @include body-semi-bold;
  margin-top: 0;
}

.fits-for-category__brand-container {
  display: flex;
  flex-direction: column;
  margin-bottom: measure(half);
  border-top: 1px solid color(border-gray);
  border-left: 1px solid color(border-gray);

  &:last-child {
    margin-bottom: 0;
  }
}

.fits-for-category__brand-headline {
  @include body-smaller-semi-bold;
  display: flex;
  align-items: center;
  min-height: 3.125rem;
  margin: 0;
  padding: measure(eighth) measure(quarter);
  background-color: color(background-white);
  border-bottom: 1px solid color(border-gray);
  border-right: 1px solid color(border-gray);

  @include media(small) {
    min-height: 3.125rem;
    padding: measure(eighth) measure(half);
  }
}

.fits-for-category__container {
  display: flex;
  flex-direction: column;
}

// .fits-for-category__models-container {
//   display: grid;
//   grid-template-columns: repeat(auto-fill, minmax(12.45rem, 1fr));

//   @include media(target-ie) {
//     display: flex;
//     flex-wrap: wrap;
//   }
// }

.fits-for-category__models-link {
  @include body-smaller-semi-bold;
  color: color(text-blue);
  display: flex;
  align-items: center;
  min-height: 2.5rem;
  padding: measure(eighth) measure(quarter);
  background-color: color(background-white);
  border-right: 1px solid color(border-gray);
  border-bottom: 1px solid color(border-gray);
  color: color(text-link);
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }

  &:last-child {
    border-right: 1px solid color(border-gray);
  }

  @include media(small) {
    flex-grow: 1;
    min-width: 11.95rem;
    height: 3.125rem;
    padding: measure(eighth) measure(half);
  }
}
</style>
